<template>
  <div class="py-64p md:py-96p bg-white relative px-6">

    <div class="text-24 md:text-32 text-navy font-bold mb-56p text-center flex flex-col justify-center items-center" data-aos="fade-up">
      <div class="mb-2 ">
        <gradient-line/>
      </div>
      <h2 class="font-bold">
        <slot name="title"/>
      </h2>

      <p class="text-16 md:text-18 text-neutral/500 font-normal text-center mt-3">
        <slot name="subtitle"/>
      </p>
    </div>

      <slot/>

  </div>
</template>

<script>
import GradientLine from '@/components/UI_components/GradientLine'
export default {
  name: 'SectionLayout',
  components: { GradientLine }
}
</script>
